// client/src/components/pages/AboutPage.js
import React, { useState, useEffect } from 'react'; // Import hooks
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import './AboutPage.css';

const AboutPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // This triggers the animation shortly after the component loads
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100); // 100ms delay to ensure styles are applied

    // Cleanup the timer if the component unmounts
    return () => clearTimeout(timer);
  }, []); // The empty array ensures this effect runs only once

  return (
    // We add a class based on the 'isVisible' state to trigger the animation
    <div className={`about-page ${isVisible ? 'is-visible' : ''}`}>
      {/* --- 1. Page Header Section --- */}
      <section className="about-header-section animate-section">
        <div className="container">
          <h1 className="about-page-title">Pioneering Medical Solutions in Tanzania</h1>
          <p className="about-page-subtitle">
            More than suppliers, we are dedicated partners in health, committed to empowering medical practitioners with the resources they need to save lives.
          </p>
        </div>
      </section>

      {/* --- 2. Our Two-Year Journey Section --- */}
      <section className="our-journey-section animate-section">
        <div className="container journey-content">
          <div className="journey-text">
            <h2>Our Two-Year Journey to Excellence</h2>
            <p>
              Established just two years ago, Makah Medics was founded on a simple yet profound principle: to bridge the gap between Tanzanian healthcare facilities and the world's finest medical technology. We began with a focused mission, a dedicated team, and a deep understanding of the challenges faced by local clinics and hospitals.
            </p>
            <p>
              Our initial focus was on mastering the complexities of dialysis solutions, where precision and reliability are matters of life and death. By building a reputation for unwavering quality and unparalleled maintenance support in this critical area, we earned the trust of leading medical institutions. This trust became the foundation of our growth.
            </p>
            <p>
              Today, from our strategic hub in Dar es Salaam, we have expanded our portfolio to cover a comprehensive range of medical necessities—from advanced diagnostic tools to essential surgical supplies—ensuring our partners have a single, reliable source for excellence.
            </p>
          </div>
          <div className="journey-image">
            <img src="/images/engineers.jpeg" alt="Makah Medics Team or Facility" />
          </div>
        </div>
      </section>

      {/* --- 3. Our Impact in Numbers Section --- */}
      <section className="our-impact-section animate-section">
        <div className="container">
          <h2>Our Impact, By The Numbers</h2>
          <div className="impact-stats-grid">
            <div className="impact-stat-card">
              <h3><CountUp end={50} duration={3} prefix="+" delay={1} /></h3>
              <p>Successful Installations Nationwide</p>
            </div>
            <div className="impact-stat-card">
              <h3><CountUp end={15} duration={3} prefix="+" delay={1} /></h3>
              <p>Regions Reached Across Tanzania</p>
            </div>
            <div className="impact-stat-card">
              <h3><CountUp end={98.6} duration={3} decimals={1} suffix="%" delay={1} /></h3>
              <p>Client Satisfaction & Retention Rate</p>
            </div>
            <div className="impact-stat-card">
              <h3><CountUp end={1200} duration={3} prefix="+" delay={1} /></h3>
              <p>Hours of Technical Training Provided</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- 4. Testimonial Showcase Section --- */}
      <section className="testimonial-showcase-section animate-section">
        <div className="container">
          <h2>What Our Partners Say</h2>
          <div className="testimonial-card-about">
            <img src="/images/testimonial1.jpeg" alt="Dr. Aisha Omar" className="testimonial-avatar" />
            <blockquote>
              "The reliability of Makah Medics' dialysis machines has been a game-changer for our unit. It's their proactive maintenance and rapid support that truly sets them apart. We feel like we have a true partner."
            </blockquote>
            <cite>
              <strong>Dr. Aisha Omar</strong><br/>
              Renal Unit Head, Mwanza City Hospital
            </cite>
          </div>
        </div>
      </section>

      {/* --- 5. Call to Action Section --- */}
      <section className="about-cta-section animate-section">
        <div className="container">
          <h2>Join Us in Building a Healthier Tanzania</h2>
          <p>Partner with a team that is as invested in your success as you are. Let's discuss how we can meet your needs.</p>
          <Link to="/contact" className="btn btn-primary">Contact Our Experts</Link>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;